import * as React from "react";
import { stylesheet } from "typestyle";
import { classNames } from "./utils.js";
export class Badge extends React.Component {
    render() {
        const { error, warning, success, className } = this.props;
        const errorStyle = error && styles.error;
        const warningStyle = warning && styles.warning;
        const successStyle = success && styles.success;
        const normalStyle = !error && !warning && !success && styles.normal;
        return (React.createElement("div", { className: classNames(styles.badge, errorStyle, warningStyle, successStyle, normalStyle, className) }, this.props.children));
    }
}
const styles = stylesheet({
    badge: {
        display: "inline-flex",
        borderRadius: "0.25em",
        fontSize: "0.875em",
        fontWeight: 500,
        padding: "0.5em 0.75em",
    },
    normal: {
        backgroundColor: "var(--color-foreground)",
        color: "var(--color-background)",
    },
    error: {
        backgroundColor: "var(--color-error)",
        color: "#fff",
    },
    warning: {
        backgroundColor: "var(--color-warning)",
        color: "#fff",
    },
    success: {
        backgroundColor: "var(--color-success)",
        color: "#fff",
    }
});
//# sourceMappingURL=badge.js.map